import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="max-w-md w-full text-center border rounded-sm p-12"
        style={{ borderColor: "var(--ggc-border)", background: "var(--ggc-surface)" }}
      >
        <h1 className="font-serif-ed text-4xl">Checkout Cancelled</h1>
        <p className="font-body text-[var(--ggc-muted)] mt-4">
          No worries — your selection is still saved. Pick up right where you left off whenever
          you're ready.
        </p>
        <Link to="/#fleet" className="inline-flex items-center gap-2 mt-8 bg-gold text-black font-label uppercase tracking-[0.2em] text-sm px-8 py-4 rounded-sm hover:bg-[var(--ggc-gold-hover)] transition-colors" data-testid="cancel-return-btn">
          <ArrowLeft size={16} /> Return To Fleet
        </Link>
      </motion.div>
    </div>
  );
}
